import { SolNavbar, SolNavbarItem } from '@sol/components';
import { AsmRouteId } from '@asm/components-core/models/asm-route-id';
import { SolIcon } from '@sol/icons';

export const navbarPartner: SolNavbar = {
  menu: [
    SolNavbarItem.of(AsmRouteId.partner_dashboard, {
      displayName: 'asm-route.partner.dashboard',
      icon: SolIcon.asm_dashboard,
    }),
    SolNavbarItem.of(AsmRouteId.partner_scopes, {
      displayName: 'asm-route.partner.scopes',
      icon: SolIcon.asm_scope,
      showChildrenInNavbar: false,
      children: [
        SolNavbarItem.of(AsmRouteId.partner_scopes_scope, {
          displayName: 'asm-route.partner.scopes-scope',
          nameParams: ['scopeName'],
          showChildrenAsTabs: true,
          children: [
            SolNavbarItem.of(AsmRouteId.partner_scopes_scope_overview, {
              displayName: 'asm-route.partner.scopes-scope-overview',
            }),
            SolNavbarItem.of(AsmRouteId.partner_scopes_scope_modules, {
              displayName: 'asm-route.partner.scopes-scope-modules',
            }),
          ],
        }),
      ],
    }),
    SolNavbarItem.of(AsmRouteId.partner_access_management, {
      displayName: 'asm-route.partner.access-management',
      icon: SolIcon.asm_access_control,
      children: [
        SolNavbarItem.of(AsmRouteId.partner_users, {
          displayName: 'asm-route.partner.users',
          icon: SolIcon.users,
        }),
        SolNavbarItem.of(AsmRouteId.partner_roles, {
          displayName: 'asm-route.partner.roles',
          icon: SolIcon.bookmark,
        }),
        SolNavbarItem.of(AsmRouteId.partner_api, {
          displayName: 'asm-route.partner.api',
          icon: SolIcon.asm_api,
          showChildrenAsTabs: true,
          children: [
            SolNavbarItem.of(AsmRouteId.partner_api_tokens, {
              displayName: 'asm-route.partner.api-tokens',
            }),
            SolNavbarItem.of(AsmRouteId.partner_api_docs, {
              displayName: 'asm-route.partner.api-docs',
            }),
          ],
        }),
      ],
    }),
    SolNavbarItem.of(AsmRouteId.partner_monitoring, {
      displayName: 'asm-route.partner.monitoring',
      children: [
        SolNavbarItem.of(AsmRouteId.partner_integrations, {
          displayName: 'asm-route.partner.integrations',
          icon: SolIcon.asm_integrations,
        }),
        SolNavbarItem.of(AsmRouteId.partner_auditLogs, {
          displayName: 'asm-route.partner.audit-logs',
          icon: SolIcon.asm_audit_logs,
        }),
      ],
    }),
    SolNavbarItem.of(AsmRouteId.partner_usage, {
      displayName: 'asm-route.partner.usage',
      icon: SolIcon.usage,
      showChildrenAsTabs: true,
      children: [
        SolNavbarItem.of(AsmRouteId.partner_usage_overview, {
          displayName: 'asm-route.usage.overview',
        }),
        SolNavbarItem.of(AsmRouteId.partner_usage_events, {
          displayName: 'asm-route.usage.events',
        }),
      ],
    }),
    SolNavbarItem.of(AsmRouteId.partner_resources, {
      displayName: 'asm-route.resources',
      icon: SolIcon.folder,
      children: [
        SolNavbarItem.of(AsmRouteId.partner_settings, {
          displayName: 'asm-route.partner.settings',
          icon: SolIcon.settings,
          showChildrenAsTabs: true,
          children: [
            SolNavbarItem.of(AsmRouteId.partner_settings_definitions, {
              displayName: 'asm-route.admin.settings-definitions',
            }),
            SolNavbarItem.of(AsmRouteId.partner_settings_rules, {
              displayName: 'asm-route.admin.settings-rules',
            }),
          ],
        }),
      ],
    }),
  ],
  system: [
    SolNavbarItem.of(AsmRouteId.debug, {
      displayName: 'asm-route.debug',
      icon: SolIcon.vulnerability,
    }),
  ],
  account: [
    SolNavbarItem.of(AsmRouteId.account_section1, {
      children: [
        SolNavbarItem.of(AsmRouteId.account_documentation, {
          displayName: 'asm-route.documentation',
        }),
        SolNavbarItem.of(AsmRouteId.account_profile, {
          displayName: 'asm-route.profile',
        }),
        SolNavbarItem.of(AsmRouteId.account_preferences, {
          displayName: 'asm-route.preferences',
        }),
      ],
    }),
    SolNavbarItem.of(AsmRouteId.account_section2, {
      children: [
        SolNavbarItem.of(AsmRouteId.account_logout, {
          displayName: 'asm-route.logout',
        }),
      ],
    }),
  ],
};
